import { required } from 'ra-core';
import { SelectInput } from '../../components/admin/select-input';
import { TextInput } from '../../components/admin/text-input';
import { KpiFormat } from './KpiFormat';
import { KPI_FORMAT } from './types';

/** The KPI form inputs, shared by create and edit */
export const KpiInputs = () => (
  <>
    <TextInput
      source="name"
      validate={required()}
      helperText="moonstar.kpis.nameHelperText"
    />
    <TextInput
      multiline
      // Like the MUI `minRows={3}` (the shadcn textarea ignores `rows` and grows with its content)
      inputClassName="min-h-20"
      source="description"
      helperText="moonstar.kpis.descriptionHelperText"
    />
    <SelectInput
      source="format"
      validate={required()}
      choices={[...KPI_FORMAT]}
      optionText={<KpiFormat />}
    />
  </>
);
